import * as React from 'react';
import { Path } from 'react-native-svg';
import { Icon, IIconProps } from 'native-base';

const SvgWarningTriangle = (props: IIconProps) => {
  return (
    <Icon viewBox="0 0 20 20" {...props}>
      <Path d="M18.666 16.719L10.541 2.656A.618.618 0 0010 2.344a.616.616 0 00-.541.312L1.334 16.72c-.24.418.06.937.541.937h16.25c.48 0 .781-.52.541-.937zM9.375 8.125c0-.086.07-.156.156-.156h.938c.086 0 .156.07.156.156v3.594c0 .086-.07.156-.156.156H9.53a.157.157 0 01-.156-.156V8.125zM10 15a.938.938 0 010-1.875A.938.938 0 0110 15z" />
    </Icon>
  );
};

export default SvgWarningTriangle;
